module.exports = __webpack_public_path__ + "static/media/varejo-3.3acaf431.jpg";